<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-keyboard-outline',
          title: 'Streamlined Loan Application',
          text: 'We know your time is valuable.  Our World Class loan process will let you focus on what is important.',
        },
        {
          icon: 'mdi-link-variant',
          title: 'Enterprise Grade Blockchain',
          text: 'We have brought the most advanced technologies to work for you.  Our next generation blockchain ensures your loan is fast, secure and future proof.',
        },
        {
          icon: 'mdi-credit-card',
          title: 'Pay The easy way',
          text: 'With the HEQ-Card-Wallet you don\'t have to worry whether or not crypto is "accepted", we handle that for you.  Accepted where Visa, Mastercard, Bitcoin... and many others are accepted.',
        },
        {
          icon: 'mdi-puzzle-outline',
          title: 'HEQ Payment Bank',
          text: 'With the HEQLOAN you will always have the ability to skip a payment using the HEQ Payment Bank.  Yes, you read that correctly.  You can skip up to 60 payments!',
        },
      ],
    }),
  }
</script>
